import * as styled from '../styles/everything-bento';

type Feature = {
  icon: string;
  title: string;
  desc: string;
  featured?: boolean;
};

const FEATURES: Feature[] = [
  {
    icon: '🔍',
    title: 'People find you',
    desc: 'Clients search Kudable for a cleaner, braider, or plumber — your profile shows up and they book you.',
    featured: true,
  },
  {
    icon: '✨',
    title: 'AI sends clients your way',
    desc: 'Someone types “my sink is leaking” — Kudable figures out who they need and shows them you.',
    featured: true,
  },
  {
    icon: '⭐',
    title: 'Verified reviews',
    desc: 'Every review tied to a real, completed booking.',
  },
  {
    icon: '🏆',
    title: 'Reputation',
    desc: 'A score that compounds with every job you finish.',
  },
  {
    icon: '📅',
    title: 'Bookings',
    desc: 'Clients book directly into your calendar.',
  },
  {
    icon: '📄',
    title: 'Quotations',
    desc: 'Send a quote, get a signed yes in seconds.',
  },
  {
    icon: '💲',
    title: 'Pricing',
    desc: 'Transparent prices clients see before they tap book.',
  },
  {
    icon: '🖼',
    title: 'Portfolio',
    desc: 'A tap-through gallery of your best work.',
  },
  {
    icon: '🎥',
    title: 'Video reviews',
    desc: 'Clients leave video testimonials, no studio needed.',
  },
  {
    icon: '🎙',
    title: 'Audio reviews',
    desc: 'One-tap voice notes from happy clients.',
  },
  {
    icon: '📷',
    title: 'Photo reviews',
    desc: 'Before/after photos travel with every review.',
  },
  {
    icon: '🎨',
    title: 'Theming & branding',
    desc: 'Brand colours and accents that make your profile yours.',
  },
  {
    icon: '🔗',
    title: 'Social links',
    desc: 'Instagram, TikTok, Facebook, WhatsApp in one bio.',
  },
  {
    icon: '💬',
    title: 'Messages',
    desc: 'In-app messaging plus WhatsApp routing.',
  },
];

export const EverythingBento = () => (
  <styled.Section>
    <styled.Inner>
      <styled.Header>
        <styled.Kicker>One link, everything</styled.Kicker>
        <styled.Headline>Everything you need to win clients</styled.Headline>
        <styled.Sub>
          Reviews, bookings, quotes, video and voice testimonials, your own
          branded profile — all in a single shareable link.
        </styled.Sub>
      </styled.Header>
      <styled.Grid>
        {FEATURES.map((feature) => (
          <styled.Tile key={feature.title} $featured={feature.featured}>
            <styled.TileIcon>{feature.icon}</styled.TileIcon>
            <styled.TileTitle>{feature.title}</styled.TileTitle>
            <styled.TileDesc>{feature.desc}</styled.TileDesc>
          </styled.Tile>
        ))}
      </styled.Grid>
    </styled.Inner>
  </styled.Section>
);
